import { CESIUM_PICKABLE_ENTITY, } from "../types";
export class CrossSectionManager {
    /**
     * <lineId, ICrossSectionData>
     */
    _lineCrossSectionInfoMap;
    constructor() {
        this._lineCrossSectionInfoMap = new Map();
    }
    addCrossSection(lineId, crossSectionData) {
        const crossSectionDataMap = new Map();
        crossSectionData.forEach((crossSection) => {
            crossSectionDataMap.set(crossSection.referencePoint.id, crossSection);
        });
        this._lineCrossSectionInfoMap.set(lineId, crossSectionDataMap);
    }
    getCrossSectionForPoint(pointId) {
        let crossSection = undefined;
        this._lineCrossSectionInfoMap.forEach((pointMap) => {
            const cs = pointMap.get(pointId);
            if (cs)
                crossSection = cs;
        });
        return crossSection;
    }
    getCrossSectionForCrossSectionEntityId(crossSectionEntityId, entityType) {
        let crossSection = undefined;
        this._lineCrossSectionInfoMap.forEach((pointMap) => {
            if (!crossSection) {
                pointMap.forEach((crossSectionData) => {
                    if (!crossSection &&
                        entityType === CESIUM_PICKABLE_ENTITY.LINEWORKS_CROSS_SECTION_LEFT) {
                        crossSectionData.leftCrossSectionPolyline.forEach((entity) => {
                            if (entity.id === crossSectionEntityId) {
                                crossSection = crossSectionData;
                            }
                        });
                    }
                    if (!crossSection &&
                        entityType === CESIUM_PICKABLE_ENTITY.LINEWORKS_CROSS_SECTION_RIGHT) {
                        crossSectionData.rightCrossSectionPolyline.forEach((entity) => {
                            if (entity.id === crossSectionEntityId) {
                                crossSection = crossSectionData;
                            }
                        });
                    }
                });
            }
        });
        return crossSection;
    }
    getCrossSectionsForLine(lineID) {
        const crossSectionMap = this._lineCrossSectionInfoMap.get(lineID);
        return crossSectionMap ? Array.from(crossSectionMap.values()) : [];
    }
    remove(lineID) {
        this._lineCrossSectionInfoMap.delete(lineID);
    }
}
//# sourceMappingURL=cross-section-manager.js.map